import { IPageInfo } from '../../models/page.types';
import { ReactNode } from 'react';
import { ErrorCode } from '../../components/UserProfile/PasswordError.types';

export interface User {
  [key: string]: string | number | boolean | JSX.Element | ReactNode;
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  pesel: string;
  examCommitteeShortName: string;
  isBlocked: boolean;
  phone: string;
}

export interface SelectedUser {
  id: string;
  firstName: string;
  lastName: string;
  userId?: string;
}

export interface UsersResponse {
  usersList: User[];
  filter: {
    [key: string]: string;
  };
  page: IPageInfo;
  sort: {
    property: string;
    isDescending: boolean | null;
  };
  total: number;
}

export interface IdentityClientResponse {
  succeeded: boolean;
  errors: IdentityClientErrors[];
}

export interface TwoFactorAuthResponse {
  logout: boolean;
  twoAuthRequired: boolean;
  smsNumber: number;
  leftAttemts: number;
  smsExpireSeconds: number;
  smsExpireDateTime: Date;
  tokenId: string;
}

export interface IdentityClientErrors {
  code: ErrorCode | string;
  description: string;
}

export enum SecurityEventTypeEnum {
  UserCreatedEvent,
  UserModifiedEvent,
  UserForcedPasswordChange,
  LoggedInEvent,
  LoggedOutEvent,
  LastRefreshTokenEvent,
  EmailConfirmed,
}
